var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFrame111(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    rx: 23,
    fill: "#D398E7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.26 18.9117C18.5267 18.6 18.215 17.6925 18.655 17.0325C19.5442 15.7125 21.0292 14.75 22.9908 14.75C25.145 14.75 26.6208 15.7308 27.3725 16.9592C28.0142 18.0133 28.39 19.9842 27.4 21.4508C26.3 23.0733 25.2458 23.5683 24.6775 24.6133C24.54 24.8608 24.4575 25.0625 24.4025 25.475C24.32 26.1442 23.77 26.6667 23.0917 26.6667C22.2942 26.6667 21.6433 25.9792 21.735 25.1817C21.79 24.7142 21.9 24.2283 22.1567 23.77C22.8625 22.4958 24.2192 21.7442 25.0075 20.6167C25.8417 19.4342 25.3742 17.225 23.0092 17.225C21.9367 17.225 21.24 17.7842 20.8092 18.4533C20.4883 18.9758 19.8192 19.1408 19.26 18.9117ZM24.8333 30.3333C24.8333 31.3417 24.0083 32.1667 23 32.1667C21.9917 32.1667 21.1667 31.3417 21.1667 30.3333C21.1667 29.325 21.9917 28.5 23 28.5C24.0083 28.5 24.8333 29.325 24.8333 30.3333Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame111);
export default __webpack_public_path__ + "static/media/Frame 111.7526aa5f4f7909f5c099d38c88125930.svg";
export { ForwardRef as ReactComponent };